import React from "react";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const visiblePages = 4;
  const startPage = Math.max(1, currentPage - 1);
  let endPage = startPage + visiblePages - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
  }

  const pagesToShow = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  const buttonStyle: React.CSSProperties = {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    // border: "1px solid #4BB0C0",
    backgroundColor: "white",
    color: "#4BB0C0",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const activeButtonStyle: React.CSSProperties = {
    ...buttonStyle, 
    backgroundColor: "#4BB0C0",
    color: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
    animation: "activePulse 0.4s ease",
  };

  const containerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginTop: "20px",
  };

  const pulseKeyframes = `
    @keyframes activePulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.15); }
      100% { transform: scale(1); }
    }
  `;

  return (
    <div style={containerStyle}>
      <style>{pulseKeyframes}</style>

      <button
        style={buttonStyle}
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {pagesToShow.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          style={currentPage === page ? activeButtonStyle : buttonStyle}
          onMouseEnter={(e) => {
            if (currentPage !== page) {
              e.currentTarget.style.backgroundColor = "#4BB0C0";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.transform = "scale(1.1)";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
            }
          }}
          onMouseLeave={(e) => {
            if (currentPage !== page) {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.color = "#4BB0C0";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }
          }}
        >
          {page}
        </button>
      ))}

      <button
        style={buttonStyle}
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
};
